IN.App.SmsverificationView = Ember.View.extend({
	init:function(){
		this._super();
	},
	onTooltipToggle: function(button, view){
		var dataTip = button.data('tip');
		var tooltip = view.find('.tooltips[data-tip="'+dataTip+'"]');
		if(button.hasClass('active')){
			button.removeClass('active');
			tooltip.removeClass('active');
		} else {
			button.addClass('active');
			tooltip.addClass('active');
		}
	},
	onForminput: function(input, event){
		if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105)) {
			if(input.val().length == 1 && event.which !== 8){
				input.next().focus();
			}
		} else {
			event.preventDefault();
			if (event.which == 8 && input.val().length == 1) {
				event.preventDefault();
				input.val('');
				input.prev().focus();
			}
			if (event.which == 8 && input.val().length == 0) {
				if(input.val() == ''){
					event.preventDefault();
					input.prev().focus();
					input.val('');
				}
				
			}
		}
	},
	willDestroyElement: function(){
		var button = this.$('.info-button');
			input = this.$('.form-control');
			
		button.unbind('click');
		input.unbind('keyup');
	},
	didInsertElement: function(){
		var view = this.$(),
			button = this.$('.info-button');
			input = this.$('.form-control');
			self = this,
			ua = navigator.userAgent,
			isiPad = /iPad/i.test(ua) || /iPhone OS 3_1_2/i.test(ua) || /iPhone OS 3_2_2/i.test(ua);
			
		input.first().focus();
		input.bind(isiPad ? 'keyup' : 'keydown', function (event) { self.onForminput($(this), event)});
		button.bind("click", function(){self.onTooltipToggle($(this), view)});
	}
});
